import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-multipartupload',
  templateUrl: './multipartupload.component.html',
  styleUrls: ['./multipartupload.component.css']
})
export class MultipartuploadComponent implements OnInit {

  copyButton: boolean = true;
  copiedButton: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }



  requestData = `
  curl -v 'https://api.optimusdrive.ai/vod/v1/customer/multipart/create' \
  -H 'authorization: XXX' \
  --data-raw '{"filename":"6min_1080pVideo.MOV"}'
  
  `

  copyToClipBoard(url: string) {
    var txtArea = document.createElement('textarea');
    txtArea.id = 'txt';
    txtArea.style.position = 'fixed';
    txtArea.style.top = '0';
    txtArea.style.left = '0';
    txtArea.style.opacity = '0';
    txtArea.value = url;
    document.body.appendChild(txtArea);
    txtArea.select();

    try {
      var successful = document.execCommand('copy');
      if (successful) {
       this.copyButton = false;
       this.copiedButton = true;
  // After a few seconds, reset the button states
      setTimeout(() => {
        this.copyButton = true;
        this.copiedButton = false;
      }, 1000);
      }
    } catch (err) {
    } finally {
      document.body.removeChild(txtArea);
    }
  }

  copyJsonToClipboard() {
    this.copyToClipBoard(this.requestData);
  }





  sucessData = `
  {
    "data": {
        "upload_id": "BiERB9GScf6epGoQqeP4wpMHg9jel_dlGf4lt2aT3tPCh1P9AcOoqToV9Cb5QpoifZYtlDT34Stt3M5E2mggZgGUlS5yOrNIAQG_7wwIqgr2BlH_kCs8nzwMpXWxckAivOUwhDDDY1B4Dtfua78BRyfugjtQOy2Qqjci5yf5r0pzYh178djIB7.auJLXm",
        "key_path": "vod/input/bc96e670-4450-42c1-a53c-5175182040e2/6aae9b72-cb80-4ba0-8f98-ef6ba184c288/6min_1080pVideo.MOV"
    },
    "message": "Success"
}


`

  Error5x = `
  {
    "error": null,
    "message": "Invalid input request. Please check your request."
  }`

  Error401x=`
  {
    "error": {},
    "message": "Unauthorized"
  }
  `

}
